import { Component  } from '@angular/core';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { LoginService } from "../services/login/login.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-cavali',
  templateUrl: './cavali.component.html',
  styleUrls: ['./cavali.component.scss']
})
export class CavaliComponent   {

  constructor(private cavaliService: CavaliService,
    private loginService: LoginService) {
  }


  clickGuard() {
    this.loginService.clickGuard = true;
  }

  cronProceso() {
    Swal.fire({
      title: 'Espere',
      text: 'Cargando transacciones pendientes.',
      type: 'info',
      heightAuto: false
    });
    Swal.showLoading();

    this.cavaliService.cronProceso().subscribe(
      resp => {
        let data: any = resp;
        Swal.fire({
          title: 'Terminado',
          text: 'Carga exitosa.',
          type: 'success',
          footer: data.data,
          heightAuto: false
        });
      },
      err => {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo cargar las transacciones.',
          type: 'error',
          heightAuto: false
        });
      }
    );
  }

  cronInformacion() {
    Swal.fire({
      title: 'Espere',
      text: 'Descargando información de las transacciones.',
      type: 'info',
      heightAuto: false
    });
    Swal.showLoading();

    this.cavaliService.cronInformacion().subscribe(
      resp1 => {
        let data: any = resp1;
        Swal.fire({
          title: 'Terminado',
          text: 'Carga exitosa.',
          type: 'success',
          footer: data.data,
          heightAuto: false
        });
      },
      err => {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo cargar información.',
          type: 'error',
          heightAuto: false
        });
      }
    );
  }
}

